// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "input,select{border-color:#e4e4e4!important}input:focus,input:hover,select:focus,select:hover{border-color:#b8dcff!important}input:focus,select:focus{outline:none!important}input[disabled]:hover,select[disabled]:hover{border-color:#e4e4e4!important}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.mx-datepicker-range{width:220px}.number:before{content:attr(data-num)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
